export * from "./employer";

export enum ApplicationStatus {
  ACCEPTED_JOB = "accepted_job",
  ADDED_TO_FAVOURITES = "added_to_favourites",
  AWAITING_FEEDBACK = "awaiting_feedback",
  COMPETENCIES_REQUIRED = "competencies_required",
  COMPETENCY_TEST_COMPLETED = "competency_test_completed",
  CONFIRMED_INTERVIEW = "confirmed_interview",
  DECLINED_INTERVIEW = "declined_interview",
  DELETED_AT = "deleted_at",
  DUPLICATE = "duplicate",
  INTERVIEW_REQUESTED_FIRST = "interview_requested_first",
  INTERVIEW_REQUESTED_SECOND = "interview_requested_second",
  INTERVIEW_REQUESTED_TELEPHONE = "interview_requested_telephone",
  INTERVIEW_REQUESTED = "interview_requested",
  INTERVIEWING = "interviewing",
  OFFER_CANCELLED = "offer_cancelled",
  OFFERED_JOB = "offered_job",
  REJECTED_CANDIDATE = "rejected_candidate",
  REJECTED_JOB = "rejected_job",
  UNSUCCESSFUL_PLACEMENT = "unsuccessful_placement",
  UNSUCCESSFUL = "unsuccessful",
}

export const ApplicationStatusGroups = {
  interviewing: [
    ApplicationStatus.INTERVIEWING,
    ApplicationStatus.INTERVIEW_REQUESTED,
    ApplicationStatus.INTERVIEW_REQUESTED_TELEPHONE,
    ApplicationStatus.INTERVIEW_REQUESTED_FIRST,
    ApplicationStatus.INTERVIEW_REQUESTED_SECOND,
    ApplicationStatus.COMPETENCIES_REQUIRED,
    ApplicationStatus.CONFIRMED_INTERVIEW,
    ApplicationStatus.OFFERED_JOB,
  ],
  feedback: [
    ApplicationStatus.AWAITING_FEEDBACK,
    ApplicationStatus.ADDED_TO_FAVOURITES,
  ],
  rejected: [
    ApplicationStatus.DUPLICATE,
    ApplicationStatus.REJECTED_CANDIDATE,
    ApplicationStatus.REJECTED_JOB,
    ApplicationStatus.UNSUCCESSFUL,
  ],
};

export type TagStatus = "success" | "warning" | "info" | "error" | "default";
